import script from "./Settings-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Settings-popup.vue?vue&type=script&setup=true&lang=js"

import "./Settings-popup.vue?vue&type=style&index=0&id=26fb4ab6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26fb4ab6"]])

export default __exports__